import React from 'react'
import { Router } from 'react-router-dom'
import { history } from './lib/history'
import Layout from './components/Layout'
import 'bulma/css/bulma.min.css'
import 'react-toastify/dist/ReactToastify.css'

export default () => (
  <Router history={history}>
    <Layout />
  </Router>
)
